import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Position closed")
const _hoisted_2 = { class: "flex-1 t-center" }
const _hoisted_3 = {
  key: 0,
  style: {"margin-bottom":"-20px"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")
  const _component_Icon = _resolveComponent("Icon")
  const _component_RealTimeQuote = _resolveComponent("RealTimeQuote")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, null, _createSlots({
    default: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        (_ctx.done)
          ? (_openBlock(), _createBlock("p", _hoisted_3, [
              _createVNode(_component_Icon, {
                name: "check",
                class: "bg-success mt-20",
                style: {"font-size":"40px","color":"white","border-radius":"20px"}
              })
            ]))
          : (_openBlock(), _createBlock(_component_RealTimeQuote, {
              key: 1,
              symbol: _ctx.symbol
            }, {
              default: _withCtx(({price, buy}) => [
                _createVNode("p", null, "Close @" + _toDisplayString(_ctx.order.type?.toString() === '1' ? price : buy), 1)
              ]),
              _: 1
            }, 8, ["symbol"]))
      ])
    ]),
    _: 2
  }, [
    (_ctx.done)
      ? {
          name: "title",
          fn: _withCtx(() => [
            _createVNode(_component_t, { path: "symbol_32" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ])
        }
      : {
          name: "title",
          fn: _withCtx(() => [
            _createVNode(_component_t, { path: "symbol_28" }, {
              default: _withCtx(() => [
                _createTextVNode("Close position")
              ]),
              _: 1
            })
          ])
        },
    (_ctx.done)
      ? {
          name: "controls",
          fn: _withCtx(() => [
            _hoisted_4
          ])
        }
      : {
          name: "confirm",
          fn: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "flex-1 primary",
              onClick: _ctx.submit,
              progress: _ctx.progress
            }, {
              default: _withCtx(() => [
                _createVNode(_component_t, {
                  path: "symbol_31",
                  custom: ""
                }, {
                  default: _withCtx(({td}) => [
                    _createTextVNode(_toDisplayString(td || 'Submit'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick", "progress"])
          ])
        }
  ]), 1024))
}